<template>
	<div class="pagination">
		<!-- Primeira página -->
		<div class="page-item first-and-last-page">
			<div @click="firstPage" v-if="currentPage !== 1">
				<router-link :to="{ query: { ...params, skip: 1 }}">Primeira</router-link>
			</div>
			<div v-else class="current-page">
				<span>Primeira</span>
			</div>
		</div>

		<!-- Página anterior -->
		<div class="page-item before-and-after">
			<div  @click="prevPage()" v-if="currentPage !== 1">
				<router-link :to="{ query: { ...params, skip: currentPage - 1 }}"><i class="fas fa-chevron-left"></i></router-link>
			</div>
			<span v-else><i class="fas fa-chevron-left"></i></span>
		</div>

		<!-- Paginação -->
		<div class="page-item" v-for="index in pages" :key="index" :class="[index === currentPage ? 'ativo' : '' ]" @click="pagina">
			<router-link :to="{ query: { ...params, skip: index }}">{{ index }}</router-link>
		</div>

		<!-- Página posterior -->
		<div class="page-item before-and-after">
			<div  @click="nextPage()" v-if="currentPage !== totalPages">
				<router-link :to="{ query: { ...params, skip: currentPage + 1 }}"><i class="fas fa-chevron-right"></i></router-link>
			</div>
			<span v-else><i class="fas fa-chevron-right"></i></span>
		</div>

		<!-- Última página -->
		<div class="page-item first-and-last-page" @click="lastPage">
			<div @click="lastPage" v-if="currentPage !== totalPages">
				<router-link :to="{ query: { ...params, skip: totalPages }}">Última</router-link>
			</div>
			<div v-else class="current-page">
				<span>Última</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Paginacao',
	props: {
		currentPage: Number,
		totalItens: Number,
		pagesQuantity: {
			type: Number,
			default: 20
		}
	},
	data () {
		return {
			totalPages: 0,
			params: {},
			pages: []
		}
	},
	created () {
		this.countPages()
		this.setPagination()

		this.params = this.$route.query ? this.$route.query : {}
	},
	methods: {
		pagina () {
			this.$emit('pagina')
		},

		firstPage () {
			if (this.currentPage !== 1) this.pagina()
		},

		lastPage () {
			if (this.currentPage !== this.totalPages) this.pagina()
		},

		nextPage () {
			this.pagina()
		},

		prevPage () {
			this.pagina()
		},

		countPages () {
			this.totalPages = Math.ceil(this.totalItens / this.pagesQuantity)
		},

		setPagination () {
			this.pages = []

			if (this.totalPages <= 10) {
				for (let i = 1; i <= this.totalPages; i++) this.pages.push(i)
			} else {
				if (this.currentPage >= 5 && this.currentPage < (this.totalPages - 5)) {
					for (let i = this.currentPage - 4; i <= this.currentPage + 5; i++) this.pages.push(i)
				} else if (this.currentPage >= 5 && this.currentPage === this.totalPages - 5) {
					for (let i = this.currentPage - 4; i <= this.totalPages; i++) this.pages.push(i)
				} else if (this.currentPage >= 5 && (this.currentPage + 5) > this.totalPages) {
					for (let i = this.totalPages - 9; i <= this.totalPages; i++) this.pages.push(i)
				} else {
					for (let i = 1; i <= 10; i++) this.pages.push(i)
				}
			}
		}
	},
	watch: {
		currentPage: function (newParams, oldParams) {
			this.countPages()
			this.setPagination()

			this.params = this.$route.query ? this.$route.query : {}

			const element = document.querySelector('.main-content')
			const top = element.offsetTop
			window.scrollTo(0, top)
		},
		totalItens: function () {
			this.countPages()
			this.setPagination()

			this.params = this.$route.query ? this.$route.query : {}
		}
	}
}
</script>

<style lang="scss" scoped>
.pagination {
	display:flex;
	justify-content: center;
	color:white;
	margin-top: 20px;

	.page-item {
		background-color:#223244;
		border-radius:5px;
		margin-left:5px;

		&.first-and-last-page  {
			background-color:#223244;

			span {
				display: flex;
				padding: 5px 15px;
				cursor: default;
				border-radius:5px;

				&:hover {
					background-color:#E2E41A;
					color:#223244;
				}
			}
		}

		&.before-and-after {
			display: flex;
			align-items: center;
			justify-content: center;
			background-color:#223244;

			span {
				display: flex;
				padding: 5px 15px;
				cursor: default;
				border-radius:5px;

				&:hover {
					background-color: #E2E41A;
					color:#223244;
				}
			}
		}

		&.ativo, &:hover {
			background-color:#E2E41A;
			color:#223244;
			border-radius:5px;
		}

		a {
			color: inherit;
			text-decoration: none;
			display: flex;
			padding: 5px 15px;
		}
	}
}
</style>
